export const checkIsIe10 = function () {
  if (window.ActiveXObject) {
    var reg = /10\.0/
    var str = navigator.userAgent
    if (reg.test(str)) {
      return true
    }
  }
  return false
}


// WEBPACK FOOTER //
// ./src/widget/PageTabs/tools.js